import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge", "count", "status"]

  connect() {
    console.log("NotificationsController connected!")
    this.loadNotificationCount()
    
    // Poll for new notifications every 10 seconds
    this.pollingTimer = setInterval(() => {
      this.loadNotificationCount()
    }, 10000)

    // Listen for page visibility changes to refresh count when user returns
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.loadNotificationCount()
      }
    })
  }

  disconnect() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
    }
  }

  async loadNotificationCount() {
    try {
      console.log('=== LOADING NOTIFICATION COUNT ===')
      const response = await fetch('/notifications/count')
      console.log('Response status:', response.status)
      if (response.ok) {
        const data = await response.json()
        console.log('Notification count data:', data)
        console.log('Count value:', data.count)
        this.updateBadge(data.count)
      } else {
        console.error('Response not ok:', response.status, response.statusText)
      }
    } catch (error) {
      console.error('Error loading notification count:', error)
    }
  }

  updateBadge(count) {
    console.log('=== UPDATING BADGE ===')
    console.log('Count received:', count)
    console.log('Badge target:', this.badgeTarget)
    console.log('Count target:', this.countTarget)
    
    if (count > 0) {
      console.log('Showing badge with count:', count)
      this.badgeTarget.style.display = 'flex'
      this.countTarget.textContent = count > 99 ? '99+' : count
      console.log('Badge should now be visible')
      
      // Update status if status target exists
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = `${count} unread`
        this.statusTarget.className = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800'
      }
    } else {
      console.log('Hiding badge (count is 0)')
      this.badgeTarget.style.display = 'none'
      console.log('Badge should now be hidden')
      
      // Update status if status target exists
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = 'All caught up'
        this.statusTarget.className = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800'
      }
    }
  }

  // Public method to refresh count immediately
  refreshCount() {
    this.loadNotificationCount()
  }
}
